export const image = url => url? url:process.env.PUBLIC_URL + "/backgrounds/revisionTask/nature.png";

export const fixName = (name) => {
  if(!name) return;
  const charArrays = ["?", "+", "&", "/"];
  charArrays.forEach((c) => {
    name = name.replaceAll(c, "");
  });
  return name;
}